// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1qFHm","overflowing":"ReadFullNote_overflowing__2kCCR"};